import React, { useEffect, useState } from "react";
import CompanyDetails from "./CompanyDetails";
import UserProfile from "./UserProfile";
import Theme from "./Theme";
import Security from "./Security";
import ChangePassword from "./ChangePassword";
import { getCompanyDetails } from "../../../../services/CommonService";
import Utils from "../../../../utils";
import DeleteUser from "./DeleteUser";

function SettingAccount() {
    const [loading, setLoading] = useState(false);
    const [companyData, setCompanyData] = useState({});
    const [themeList, setThemeList] = useState([]);
    const [isThemeTab, setIsThemeTab] = useState(true);
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        setLoading(true);
        getCompanyDetails()
            .then((response) => {
                setLoading(false);
                setCompanyData(response.data.data);
                setThemeList(response.data.themeList);
                console.log("Fetched Company Data:", response.data.data);
            })
            .catch((err) => {
                setLoading(false);
                console.error("Error fetching company details:", err);
            });
    }, []);

    useEffect(() => {
        let loginData = Utils.loginUserData();
        console.log("Logged-in User Data:", loginData);

        if (loginData && Object.keys(loginData).length > 0) {
            setCurrentUser(loginData);
            if (loginData.role_id > 3) {
                setIsThemeTab(false);
            }
        } else {
            console.warn("No logged-in user data found!");
        }
    }, []);

    return (
        <>
            {loading && (
                <div className="page-loading">
                    <img src="/images/loader.gif" alt="loader" />
                </div>
            )}
            <div
                className="tab-pan active show"
                id="Account-detail"
                role="tabpanel"
                aria-labelledby="AccountDetails"
            >
                <div className="breadcrumbs">
                    <ul>
                        <li>Settings /</li>
                        <li>Account</li>
                    </ul>
                </div>

                <div className="nav nav-tabs pt-4 d-sm-flex border-0" id="nav-tab" role="tablist">
                    <button
                        className="nav-link me-2 mb-2 active"
                        id="nav-companyDetails"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-company-detail"
                        type="button"
                        role="tab"
                        aria-controls="nav-company-detail"
                        aria-selected="true"
                    >
                        Company Details
                    </button>
                    <button
                        className="nav-link me-2 mb-2"
                        id="nav-profile-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-profile"
                        type="button"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="false"
                    >
                        User Profile
                    </button>
                    {/* {isThemeTab && (
                        <button
                            className="nav-link me-2 mb-2"
                            id="nav-theme-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#nav-theme"
                            type="button"
                            role="tab"
                            aria-controls="nav-theme"
                            aria-selected="false"
                        >
                            Theme
                        </button>
                    )} */}
                    <button
                        className="nav-link me-2 mb-2"
                        id="nav-Security-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-Security"
                        type="button"
                        role="tab"
                        aria-controls="nav-Security"
                        aria-selected="false"
                    >
                        Security
                    </button>
                    <button
                        className="nav-link me-2 mb-2"
                        id="nav-Change-Password-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-Change-Password"
                        type="button"
                        role="tab"
                        aria-controls="nav-Change-Password"
                        aria-selected="false"
                    >
                        Change Password
                    </button>
                    <button
                        className="nav-link me-2 mb-2"
                        id="nav-account-delete-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-account-delete"
                        type="button"
                        role="tab"
                        aria-controls="nav-account-delete"
                        aria-selected="false"
                    >
                        Account Delete
                    </button>

                </div>

                <div className="tab-content account_accordiom" id="nav-tabContent"
                    style={{ minHeight: "calc(100vh - 247px)", marginBottom: 30 }}>

                    <div className="tab-pane fade show active" id="nav-company-detail" role="tabpanel">
                        <CompanyDetails companyData={companyData} setCompanyData={setCompanyData} setLoading={setLoading} />
                    </div>

                    <div className="tab-pane fade" id="nav-profile" role="tabpanel">
                        <UserProfile companyData={companyData} setLoading={setLoading} />
                    </div>

                    {isThemeTab && (
                        <div className="tab-pane fade" id="nav-theme" role="tabpanel">
                            <Theme themeList={themeList} setThemeList={setThemeList} setLoading={setLoading} />
                        </div>
                    )}

                    <div className="tab-pane fade" id="nav-Security" role="tabpanel">
                        <Security />
                    </div>

                    <div className="tab-pane fade" id="nav-Change-Password" role="tabpanel">
                        <ChangePassword />
                    </div>

                    {/* Fix: DeleteUser should be inside tab-pane */}
                    <div className="tab-pane fade" id="nav-account-delete" role="tabpanel">
                        <DeleteUser
                            setLoading={setLoading}
                            email={currentUser?.email || ""}
                            firstName={currentUser?.first_name || ""}
                            lastName={currentUser?.last_name || ""}

                        />
                    </div>

                </div>
            </div>
        </>
    );
}

export default SettingAccount;
